var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarXStreamlineLucide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43848 2.8457V6.90737",
    stroke: "#FF725E",
    strokeWidth: 1.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5615 2.8457V6.90737",
    stroke: "#FF725E",
    strokeWidth: 1.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39216 4.87695H20.608C20.608 4.87695 22.6388 4.87695 22.6388 6.90779V21.1236C22.6388 21.1236 22.6388 23.1545 20.608 23.1545H6.39216C6.39216 23.1545 4.36133 23.1545 4.36133 21.1236V6.90779C4.36133 6.90779 4.36133 4.87695 6.39216 4.87695Z",
    stroke: "#FF725E",
    strokeWidth: 1.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36133 10.9688H22.6388",
    stroke: "#FF725E",
    strokeWidth: 1.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5304 15.0312L11.4688 19.0929",
    stroke: "#FF725E",
    strokeWidth: 1.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 15.0312L15.5304 19.0929",
    stroke: "#FF725E",
    strokeWidth: 1.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarXStreamlineLucide);
export default __webpack_public_path__ + "static/media/Calendar-X--Streamline-Lucide.887ca471db3c6c45ee3e56dbd8172206.svg";
export { ForwardRef as ReactComponent };